import { useMemo } from "react";
import useSearchWords from "hooks/useSearchWords";
import useQuery from "hooks/useQuery";

export interface LoanStatusPropsHook {
  color: string;
  priceColor: string;
  classNames: {
    wrapperClassName: string;
    poundsClassName: string;
    centsClassName: string;
  };
  searchWords: string[];
}

export default function useLoanStatusProps(
  status: string
): LoanStatusPropsHook {
  const [query] = useQuery("loans");
  const searchWords = useSearchWords(query);

  const color = useMemo(() => {
    if (status === "accepted") return "green";
    if (status === "declined") return "violet";
    if (status === "referred") return "blue";
    if (status === "action_lender") return "lavender";
    if (status === "action_customer") return "lavender";
    if (status === "pending") return "blue";
    if (status === "finished") return "green";
    if (status === "paid_out") return "green";
    return "grey";
  }, [status]);

  const priceColor = useMemo(() => {
    if (status === "accepted") return "green-500";
    if (status === "declined") return "violet-200";
    if (status === "referred") return "blue-200";
    if (status === "action_lender") return "lavender-200";
    if (status === "action_customer") return "lavender-200";
    if (status === "pending") return "blue-200";
    if (status === "finished") return "green-500";
    if (status === "paid_out") return "green-500";
    return "neutral-700";
  }, [status]);

  const classNames = {
    wrapperClassName: "my-auto",
    poundsClassName: "text-16-20-em",
    centsClassName: "text-16-20-em",
  };

  return {
    color,
    priceColor,
    classNames,
    searchWords,
  };
}
